<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <v-row>
          <v-col md="4">Company Name:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else> {{ partner.company_name }} </div>
          </v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'partner'">
          <v-col md="4">Total Account Managers:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else> {{ partner.total_account_manager }} </div>
          </v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'partner'">
          <v-col md="4">Total Customers:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else> {{ partner.total_members }} </div>
          </v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'senso'">
          <v-col md="4">Total Users:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else> {{ partner.total_members }} </div>
          </v-col>
        </v-row>
        <v-row v-if="$globalConfig.APP_NAME == 'senso'">
          <v-col md="4">Total Tier Two Partners:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else>{{ partner.total_partnert2 }}</div></v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col md="4">Administrator:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else>{{ partner.first_name }} {{partner.last_name}}</div></v-col>
        </v-row>
        <v-row>
          <v-col md="4">Email:</v-col>
          <v-col md="8">
            <div class="skeleton-box" style="width: 50%; height: 16px; border-radius: 10px;" v-if="!partner.company_name"></div>
            <div v-else>{{ partner.email }}</div></v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import partnerAPI from "@/api/partner.js";

export default {
  name: "SuperAdminPartnerDetails",
  data() {
    return {
      partner: [],
      loading: false,
      partnerId: this.$route.params.id,
    };
  },
  mounted() {
    this.getPartnerData();
  },
  computed: {},
  watch: {},
  methods: {
    getPartnerData() {
      this.loading = true;
      partnerAPI.getPartnerByID(this.partnerId).then(resp => {
        this.partner = resp.data.data;
        this.loading = false;
      });
    }
  }
};
</script>